import { useLocation, matchPath } from 'react-router-dom';

export function useActiveLink(path, deep = true) {
  const { pathname } = useLocation();

  const target = typeof path === 'string' ? path : null;

  const normalActive = target ? !!matchPath({ path: target, end: true }, pathname) : false;

  const deepActive = target ? !!matchPath({ path: target, end: false }, pathname) : false;

  return deep ? deepActive : normalActive;
}
